export function initPopup($) {
    const POPUP_KEY = "jn_popup_seen";
    const $modal = $("#inventory-notice");

    function isTargetPage(path) {
        return (
            path.startsWith("/garden-centre") ||
            path.startsWith("/product-category/")
        );
    }

    $(document).ready(() => {
        const path = window.location.pathname;

        if (!isTargetPage(path)) return;

        const hasSeenPopup = localStorage.getItem(POPUP_KEY);

        if (!hasSeenPopup) {
            $modal.removeClass("hidden");
            localStorage.setItem(POPUP_KEY, "true");
        }

        $('[data-modal-exit]').on("click", () => {
            $modal.addClass("hidden");
        })
    })


}